var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-35.56 -35.56 579.12 579.12",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M465.7,0H42.3C19,0,0,19,0,42.3v318.9c0,23.3,19,42.3,42.3,42.3H195v24l-58.7,52.3h-35c-7.8,0-14.1,6.3-14.1,14.1 c0,7.8,6.3,14.1,14.1,14.1h305.5c7.8,0,14.1-6.3,14.1-14.1s-6.3-14.1-14.1-14.1h-35L313,427.5v-23.9h152.7 c23.3,0,42.3-19,42.3-42.3v-319C508,19,489,0,465.7,0z M28.2,42.3c0-7.8,6.3-14.1,14.1-14.1h423.3c7.8,0,14.1,6.3,14.1,14.1v262.6 h-28.1V70.6c0-7.8-6.3-14.1-14.1-14.1H70.6c-7.8,0-14.1,6.3-14.1,14.1V305H28.2V42.3z M108,194H84.7v-28.2h51.6 c7.8,0,14.1-6.3,14.1-14.1c0-7.8-6.3-14.1-14.1-14.1H84.7V84.7h338.7V305H84.7v-82.7H108c7.8,0,14.1-6.3,14.1-14.1 C122.1,200.3,115.8,194,108,194z M329.3,479.8H178.7l39.8-35.4c3-2.7,4.7-6.5,4.7-10.5v-30.3h61.6v30.3c0,4.4,2.1,8.4,5.3,11 L329.3,479.8z M479.8,361.2L479.8,361.2c0,7.8-6.3,14.1-14.1,14.1h-35.6v-9.7c0-7.8-6.3-14.1-14.1-14.1c-7.8,0-14.1,6.3-14.1,14.1 v9.7h-28.2v-9.7c0-7.8-6.3-14.1-14.1-14.1s-14.1,6.3-14.1,14.1v9.7H42.3c-7.8,0-14.1-6.3-14.1-14.1v-28.1h451.6V361.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4);
export default __webpack_public_path__ + "static/media/item4.f3fe0b346828f6079526fcc9f185934d.svg";
export { ForwardRef as ReactComponent };